import { Loader2 } from 'lucide-react';

export default function Spinner({ size = 20, className = 'text-accent' }) {
  // El color viene solo de `className` (nunca se combinan dos utilidades de
  // color de Tailwind a la vez — el ganador entre dos clases con la misma
  // especificidad depende del orden de generación, no del orden del atributo).
  return <Loader2 size={size} className={`animate-spin ${className}`} />;
}
